// extracted by mini-css-extract-plugin
module.exports = {"link":"DownloadLink_link__PeSzB","icon":"DownloadLink_icon__hBonT"};